export default function mainHeader() {
    const headerWrapper = document.querySelector('.main-header__wrapper');
    const header = document.querySelector('.main-header');
    if (headerWrapper && header) {
        header.style.height = `${headerWrapper.clientHeight}px`;
        headerWrapper.style.position = 'fixed';
    }
}
